import { getMethodWithToken } from 'services/apiServices';
import url from 'services/urls.json';
import { ClearTokenRedirectLogin } from 'utils/general';

// Action Lists
export const GET_CURRENCY_LIST = 'GET_CURRENCY_LIST';
export const GET_CURRENCY_LIST_SUCCESS = 'GET_CURRENCY_LIST_SUCCESS';
export const GET_CURRENCY_LIST_FAILURE = 'GET_CURRENCY_LIST_FAILURE';

// Action Creators
export const fetchGetCurrencyList = () => ({
  type: GET_CURRENCY_LIST,
});

export const fetchGetCurrencyListSuccess = (data) => ({
  type: GET_CURRENCY_LIST_SUCCESS,
  payload: data,
});

export const fetchGetCurrencyListFailure = (error) => ({
  type: GET_CURRENCY_LIST_FAILURE,
  payload: error,
});

// Thunk Function
export const getCurrencyListCallAPI = (data, external = {}) => {
  return async (dispatch) => {
    dispatch(fetchGetCurrencyList(data, external));
    try {
      const response = await getMethodWithToken(url.getCurrency);
      if (response.status === 200 || response.status === 201) {
        dispatch(fetchGetCurrencyListSuccess(response.data));

        if (external && external.redirect === true) {
          external.redirectNavigate(external.path);
        } else if (external && external.run === true) {
          external.handleFunction(response);
        } else if (external && external.step) {
          external.handleStep(external.step);
        }
      } else if (response.status === 401) {
        ClearTokenRedirectLogin(external?.navigate);
      } else {
        dispatch(fetchGetCurrencyListFailure('Error'));
        if (external && external.toast) {
          external.handleToastError(response);
        }
      }
    } catch (error) {
      dispatch(fetchGetCurrencyListFailure(error.message));
    }
  };
};
